import { jwtDecode } from 'jwt-decode';

// Returns null for a malformed token (jwtDecode throws on garbage) — ProtectedRoute relies on that to send a
// tampered/corrupted stored token back to login instead of crashing. `exp` (seconds since epoch) feeds its
// client-side expiry check; the server-side 401 interceptor in api/index.js remains the authority.
export const decodeToken = (token) => {
  try {
    const decoded = jwtDecode(token);

    const userRole =
      decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    const userName =
      decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

    return { userRole, userName, exp: decoded.exp };
  } catch {
    return null;
  }
};
